import { Box, Button, Typography, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

/**
 * Error fallback component displayed when a React error boundary catches an error.
 *
 * This is used with Sentry.ErrorBoundary to provide a user-friendly error page
 * when catastrophic React errors occur in production. The error is automatically
 * reported to Sentry before this fallback is shown.
 */
export function SentryErrorFallback() {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        p: 3,
        bgcolor: 'background.default',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          textAlign: 'center',
          maxWidth: 400,
          borderRadius: 3,
        }}
      >
        <ErrorOutlineIcon
          sx={{
            fontSize: 64,
            color: 'error.main',
            mb: 2,
          }}
        />
        <Typography variant="h5" component="h1" gutterBottom>
          Something went wrong
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          We've been notified and are working to fix this issue. Please try refreshing the page.
        </Typography>
        <Button variant="contained" onClick={handleRefresh} size="large">
          Refresh Page
        </Button>
      </Paper>
    </Box>
  );
}
